import React from 'react';
import KeyboardReact from 'react-simple-keyboard';
import { useIntl } from 'react-intl';

import {
  BUTTON_LABELS,
  OPTIONS_BY_LANG,
  getWritableInputTypesConfig,
} from '../../utils/KeyUtils';
import shiftLock from '../../modules/shiftLock';
import multiKeyboards from '../../modules/multiKeyboards';
import specialTypes from '../../modules/specialTypes';

import type { KeyboardComponentProps } from '../types';
import { DEFAULT_THEME, SPECIAL_KEYS } from 'components/Keyboard/utils/constants';

const BUTTON_THEME = [
  {
    class: '!bg-gray-300',
    buttons: `${SPECIAL_KEYS.BACKSPACE} ${SPECIAL_KEYS.SHIFT} ${SPECIAL_KEYS.CONFIRM} ${SPECIAL_KEYS.ENTER}`,
  },
  {
    class: '!bg-gray-300 !w-28 !flex-grow-0',
    buttons: `${SPECIAL_KEYS.NEXT_KEYBOARD}`,
  },
  {
    class: '!max-w-[100px] !min-w-[50px]',
    buttons: '@',
  },
  {
    class: '!w-[20px]',
    buttons: `${SPECIAL_KEYS.BACKSPACE}`,
  },
];

const MODULES = [shiftLock, multiKeyboards, specialTypes];

const DefaultKeyboard: React.FC<KeyboardComponentProps> = ({
  type,
  language,
  layoutType,
  layoutCandidates,
  onInit,
  onChange,
  keyboardRef,
  onKeyReleased,
  onSelectionChange,
}) => {
  const intl = useIntl();
  const display = React.useMemo(() => BUTTON_LABELS(intl), [intl]);

  const excludedKeys = React.useMemo(
    () => getWritableInputTypesConfig(language)[type]?.excludedKeys,
    [type, language],
  );

  const layoutCandidatesPageSize = React.useMemo(
    () => OPTIONS_BY_LANG[language].layoutCandidatesPageSize,
    [language],
  );

  return (
    <KeyboardReact
      type={type}
      mergeDisplay
      newLineOnEnter
      onInit={onInit}
      display={display}
      modules={MODULES}
      onChange={onChange}
      language={language}
      layoutType={layoutType}
      keyboardRef={keyboardRef}
      buttonTheme={BUTTON_THEME}
      onKeyReleased={onKeyReleased}
      excludeFromLayout={excludedKeys}
      layoutCandidates={layoutCandidates}
      layoutCandidatesCaseSensitiveMatch
      onSelectionChange={onSelectionChange}
      theme={`${DEFAULT_THEME} fb-keyboard`}
      layoutCandidatesPageSize={layoutCandidatesPageSize}
    />
  );
};

export default DefaultKeyboard;
